"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonReset = void 0;
const styled_components_1 = require("styled-components");
exports.buttonReset = (0, styled_components_1.css) `
    font-family: inherit;
    font-size: 100%;
    padding: 0;
    margin: 0;
    outline: none;
    border: none;
    background: none;

    &:focus {
        outline: none;
    }
`;
//# sourceMappingURL=buttonReset.styles.js.map